import { evaluateLayerPoseAtGlobalTime, type LayerPose } from '@/animation/evaluateLayerPoseAtGlobalTime'
import type { AnimationLayer } from '@/types/animationLayer'

export type { LayerPose } from '@/animation/evaluateLayerPoseAtGlobalTime'

/**
 * 在给定全局时刻求图层姿态（clip 模型）；为兼容旧 API 名保留。
 *
 * @param layer - 动画图层
 * @param timeSeconds - 全局时间轴时刻（秒）
 */
export function evaluateLayerAtTime(layer: AnimationLayer, timeSeconds: number): LayerPose {
  return evaluateLayerPoseAtGlobalTime(layer, timeSeconds)
}
